import React, { useCallback, useState, useMemo } from "react";
import {
  FoodyWeekContainer,
  HeaderContainer,
  H1,
  GetAppBannerContainer,
  AppStoreImage,
  MobileAppImages,
  MobileAppImageSmall,
  MobileAppImageBig,
  Divider,
  ImageHeroContainer,
  RecipeHeroImage,
  HeaderIconsContainer,
} from "./styled";
import cloudfront from "helpers/cloudfront";
import DownloadAppModal from "components/DownloadAppModal";
import RecipeCard from "./components/RecipeCard";
import DownloadModal from "./components/DowloadModal";
import { RecipesCardsWrap } from "components/ProfilePage/Products/styled";

import { useRenderDevice } from "helpers/hooks/useRenderDevice";

const CollectionShare = (props) => {
  const [donwloadModalVisible, setDownloadModalVisible] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [bannerSize, setBannerSize] = useState("xLarge");
  const [showAll, setShowAll] = useState(false);

  const isMobile = useRenderDevice({ max: 769 });

  const renderContent = useMemo(() => {
    if (props.collection.description) {
      if (showAll || props.collection.description.length <= 200) {
        return props.collection.description;
      }
      return props.collection.description.slice(0, 200) + "...";
    }

    return "";
  }, [props.collection, showAll]);

  const showModal = useCallback(() => {
    setIsModalVisible(true);
  });

  const toggleShowAll = () => setShowAll(!showAll);

  const openAppStoreLink = () => {
    window.open("https://apps.apple.com/si/app/foody/id6443809822", "_blank");
  };

  return (
    <FoodyWeekContainer>
      <ImageHeroContainer>
        <RecipeHeroImage
          src={cloudfront({ href: props.collection.main_image_url, size: bannerSize })}
          alt="collection"
          onError={() => {
            setBannerSize("large");
          }}
        />
      </ImageHeroContainer>
      <HeaderContainer>
        <H1>{props.collection.title}</H1>
        <HeaderIconsContainer>
          <div>
            <img src={"/images/recipe.svg"} alt="recipe" />
            <span>
              {props.collection.number_of_recipes} {props.collection.number_of_recipes > 1 ? "Recipes" : "Recipe"}
            </span>
          </div>
          <div>
            <img src={"/images/channel-link.svg"} alt="channel" />
            <span>{props.collection.channel.title}</span>
          </div>
        </HeaderIconsContainer>
        {isMobile && (
          <div>
            {renderContent.split("\n").map((val, i) => {
              if (i === renderContent.split("\n").length - 1) {
                return (
                  <p key={i}>
                    {val}{" "}
                    {props.collection.description.length > 200 && (
                      <button onClick={toggleShowAll} style={{ color: "#111" }}>
                        {showAll ? "See Less" : "See More"}
                      </button>
                    )}
                  </p>
                );
              }

              return <p key={i}>{val}</p>;
            })}
          </div>
        )}
        {!isMobile && <p>{props.collection.description}</p>}
      </HeaderContainer>

      <div style={{ width: "80%", maxWidth: 800 }}>
        <Divider />
        <GetAppBannerContainer>
          <div>
            <h1>Get the App!</h1>
            <p>Never wonder what's for dinner with personalized meal plans just for you in the Foody+ app.</p>
            <AppStoreImage src="/images/appleStore.png" alt="App Store" onClick={openAppStoreLink} />
          </div>
          <MobileAppImages>
            <MobileAppImageBig src="/images/mobile-app-1.png" alt="iphone1" />
            <MobileAppImageSmall src="/images/mobile-app-2.png" alt="iphone2" />
          </MobileAppImages>
        </GetAppBannerContainer>

        <RecipesCardsWrap>
          {props.recipes.length > 0 ? (
            props.recipes.map((recipe) => (
              <RecipeCard
                key={recipe.id}
                isPrivateCollection={recipe.paid}
                item={{ recipe }}
                showModal={showModal}
                isNewLanding={true}
              />
            ))
          ) : (
            <div style={{ padding: "0 0 4rem 0", textAlign: "center", width: "100%" }}>No recipes</div>
          )}
        </RecipesCardsWrap>

        {props.recipes.length >= 30 && (
          <div style={{ padding: "0 0 4rem 0", textAlign: "center", width: "100%" }}>
            See more recipes in Foody+ App!
          </div>
        )}
      </div>

      <DownloadAppModal visible={donwloadModalVisible} onClose={() => setDownloadModalVisible(false)} />
      <DownloadModal
        isOpen={isModalVisible}
        onClose={() => {
          setIsModalVisible(false);
        }}
      />
    </FoodyWeekContainer>
  );
};

export default CollectionShare;
